module.exports = __webpack_public_path__ + "img/v8.2eca1339.jpg";